<template>
  <div v-bind:class="{ 'promo-pricing-modal-container': true, show: show }">
    <div class="promo-pricing-modal">
      <div class="promo-pricing-modal-content">
        <div class="promo-pricing-form">
          <div class="title">NEW PROMOTIONAL PRICING</div>
          <div class="select-input">
            <label>SERVICE TYPE</label>
            <select v-model="promoForm.serviceType">
              <option value="">Choose One</option>
              <option v-for="service in services" :value="service.id">{{ service.name }}</option>
            </select>
          </div>
          <div class="select-input">
            <label>PROMOTION TYPE</label>
            <select v-model="promoForm.promoType">
              <option value="">Choose One</option>
              <option value="flat">Flat Rate</option>
              <option value="discount">Discount Mileage Rate</option>
            </select>
          </div>
          <div class="text-input" v-show="promoForm.promoType === 'flat'">
            <label>FLAT RATE</label>
            <vue-autonumeric v-model="promoForm.flatRate" :options="dollar"></vue-autonumeric>
          </div>
          <div class="text-input" v-show="promoForm.promoType === 'discount'">
            <label>BASE RATE</label>
            <vue-autonumeric v-model="promoForm.baseRate" :options="dollar"></vue-autonumeric>
          </div>
          <div class="text-input" v-show="promoForm.promoType === 'discount'">
            <label>MILEAGE RATE</label>
            <vue-autonumeric v-model="promoForm.mileageRate" :options="dollar"></vue-autonumeric>
          </div>
          <div class="text-input" v-show="promoForm.promoType !== ''">
            <label>2ND PAX FEE</label>
            <vue-autonumeric v-model="promoForm.secondPaxFee" :options="dollar"></vue-autonumeric>
          </div>
          <div class="text-input" v-show="promoForm.promoType !== ''">
            <label>ADDITIONAL PAX FEE</label>
            <vue-autonumeric v-model="promoForm.addPaxFee" :options="dollar"></vue-autonumeric>
          </div>
          <div class="promo-error" v-show="promoForm.error.show">{{ promoForm.error.message }}</div>
          <div class="controls">
            <a v-bind:class="{ 'button xsmall cta secondary': true, disabled: promoForm.saving }"
               href="javascript:;" @click="hideForm">CANCEL</a>
            <a v-bind:class="{ 'button xsmall cta success': true, disabled: promoForm.saving }" href="javascript:;" @click="addPromo">
              <i class="fa fa-spinner fa-spin" v-show="promoForm.saving"></i>
              <span v-show="!promoForm.saving">SAVE</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
import VueAutonumeric from 'vue-autonumeric'
import services from '@/modules/api/services'
export default {
  name: 'promo',
  components: { VueAutonumeric },
  data () {
    return {
      dollar: {
        currencySymbol: '$ ',
        currencySymbolPlacement: 'p',
        minimumValue: '0',
        maximumValue: '99.99',
        emptyInputBehavior: 'zero'
      },
      promoForm: {
        saving: false,
        serviceType: '',
        promoType: '',
        flatRate: 0,
        baseRate: 0,
        mileageRate: 0,
        secondPaxFee: 0,
        addPaxFee: 0,
        error: {
          show: false,
          message: ''
        }
      }
    }
  },
  computed: {
    show () { return this.$store.state.pricing.promo.show },
    activeGeofenceId () { return this.$store.state.pricing.serviceArea.activeId },
    selectedBrand () { return this.$store.state.pricing.brandId },
    services () { return this.$store.state.pricing.serviceTypes.list.filter(x => x.brandId === this.selectedBrand && x.brandEnabled && x.enabled) },
    promoList () { return this.$store.state.pricing.promo.list }
  },
  methods: {
    hideForm () { this.$store.commit('pricing/setGeofencePromoShow', false) },
    addPromo () {
      let self = this
      let services = CONFIG.serviceId
      let promoList = self.promoList
      for (let prop in services) {
        if (!services.hasOwnProperty(prop)) {
          continue
        }

        if (prop !== self.promoForm.serviceType) {
          continue
        }

        for (let i = 0; i < promoList.length; i++) {
          if (services[prop] === promoList[i].serviceId) {
            self.promoForm.error = {
              show: true,
              message: 'Only one promotion is allowed per service type.'
            }
            return
          }
        }
      }
      self.promoForm.error.show = false
      if (self.promoForm.serviceType === '') {
        self.promoForm.error = {
          show: true,
          message: 'Please select a SERVICE TYPE.'
        }
        return
      }
      if (self.promoForm.promoType === '') {
        self.promoForm.error = {
          show: true,
          message: 'Please select a PROMOTION TYPE.'
        }
        return
      }
      self.promoForm.saving = true
      let request = {
        token: self.$store.state.session.sessionToken,
        serviceId: self.promoForm.serviceType,
        type: self.promoForm.promoType,
        flatRate: self.promoForm.flatRate,
        flat2ndPAXFee: self.promoForm.secondPaxFee,
        flatAddPAXFee: self.promoForm.addPaxFee,
        discountBaseRate: self.promoForm.baseRate,
        discountMileageRate: self.promoForm.mileageRate,
        discount2ndPAXFee: self.promoForm.secondPaxFee,
        discountAddPAXFee: self.promoForm.addPaxFee,
      }

      self.$sdk.post('/geofences/' + self.activeGeofenceId + '/promos', request, r => {
        self.promoForm.saving = false
        if (r.error) {
          return
        }
        self.hideForm()
        self.$store.commit('pricing/setGeofencePromoRefreshID', self.activeGeofenceId)
      })
    },
    serviceLabel (code) { return services.getServiceName(code) }
  },
  watch: {
    show (value) {
      if (!value) {
        return
      }
      this.promoForm = {
        saving: false,
        serviceType: '',
        promoType: '',
        flatRate: 0,
        baseRate: 0,
        mileageRate: 0,
        secondPaxFee: 0,
        addPaxFee: 0,
        error: {
          show: false,
          message: ''
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.promo-pricing-modal-container {
  position: fixed;
  top: -100%;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.5);
  z-index: 13;
  opacity: 0;
  transition: all 250ms;

  &.show {
    top: 0;
    opacity: 1;
  }

  & .promo-pricing-modal {
    display: table;
    width: 100%;
    height: 100%;
  }

  & .promo-pricing-modal-content {
    display: table-cell;
    vertical-align: middle;
  }

  & .promo-pricing-form {
    background-color: #fff;
    border-radius: 3px;
    width: 400px;
    margin: 0 auto;
    box-shadow: 0 2px 8px rgba(0,0,0,0.3);
    padding: 15px;

    & .title {
      text-align: center;
      color: #0D79F2;
      font-size: 14px;
      font-weight: 700;
      margin-bottom: 15px;
    }

    & .select-input {
      margin-bottom: 10px;
      & label {
        color: #0D79F2;
        font-size: 10px;
        font-weight: 700;
      }

      & select {
        font-size: 14px;
        outline: 0;
        padding: 10px;
        border-color: rgba(0,0,0,0.15);
        background-color: #fff;
        border-radius: 3px;
        height: 43px;
      }
    }

    & .text-input {
      margin-bottom: 10px;
      & label {
        color: #0D79F2;
        font-size: 10px;
        font-weight: 700;
      }

      & input {
        margin-top: 0;
        font-size: 14px;
      }
    }

    & .promo-error {
      font-size: 12px;
      font-weight: 700;
      text-align: center;
      padding: 10px;
      border: 1px solid #F20D0D;
      border-radius: 3px;
      color: #F20D0D;
    }

    & .controls {
      text-align: center;
      margin-top: 15px;

      & .button {
        width: 70px;
        height: 33px;
      }
    }
  }
}

@media only screen and (max-width: 430px) {

  .promo-pricing-modal-container {
    .promo-pricing-form {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Pricing/Promo.vue